<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed light bootsnav" />
    <PicBanner :title="$t('about.title')" bgImg="/img/about.jpeg"></PicBanner>
    <Intro />
    <Team />
    <Service />
    <Client />
    <Footer />
    <FollowModal />
    <SubscribeModal />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PicBanner from '@/components/PicBanner.vue'
import Intro from '@/components/about/Intro.vue'
import Team from '@/components/about/Team.vue'
import Service from '@/components/about/Service.vue'
import Client from '@/components/about/Client.vue'
import Footer from '@/components/Footer.vue'
import FollowModal from '@/components/FollowModal.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'

export default {
  name: 'about',
  components: {
    Nav,
    PicBanner,
    Intro,
    Team,
    Service,
    Client,
    Footer,
    FollowModal,
    SubscribeModal
  },
  created: function() {
    //console.log(this.$i18n.locale)
  }
}
</script>
